import { useEffect } from "react";
import React from "react";
import * as Sentry from "@sentry/react";

let lastErrorTime = 0;
const ERROR_THROTTLE_MS = 1000; // Minimum time between error reports

export const reportError = (error, context = {}) => {
	const now = Date.now();

	// Throttle error reporting
	if (now - lastErrorTime < ERROR_THROTTLE_MS) {
		return;
	}

	// Update last error time
	lastErrorTime = now;

	// Only report in production
	if (process.env.NODE_ENV === "production") {
		Sentry.captureException(error, {
			extra: context,
			tags: {
				errorType: error.name,
				component: context.componentName,
			},
		});
	} else {
		console.error("Error:", error, "Context:", context);
	}
};

export const useScrollAnimation = (
	targetSelector,
	threshold = 0.1,
	rootMargin = "0px"
) => {
	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add("scroll-show");
					} else {
						entry.target.classList.remove("scroll-show");
					}
				});
			},
			{
				threshold: threshold,
				rootMargin: rootMargin,
			}
		);

		// Observe all elements matching the selector
		document.querySelectorAll(targetSelector).forEach((element) => {
			element.classList.add("scroll-hidden");
			observer.observe(element);
		});

		return () => observer.disconnect();
	}, [targetSelector, threshold, rootMargin]);
};

export function createSlug(title) {
	if (!title) return "";
	return title
		.toLowerCase()
		.trim()
		.replace(/&/g, "and") // Replace ampersand with 'and'
		.replace(/[^\w\s:-]/g, "") // Remove special characters except colon
		.replace(/\s+/g, "-") // Replace spaces with hyphens
		.replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
		.replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
}

export const SkeletonLoader = ({
	count = 1,
	height = "20px",
	width = "100%",
	margin = "10px 0",
	borderRadius = "4px",
	animation = true,
}) => {
	const skeletonElements = Array(count)
		.fill(null)
		.map((_, index) => (
			<div
				key={index}
				className="skeleton-loader"
				style={{
					height,
					width,
					margin,
					borderRadius,
					backgroundColor: "#eee",
					position: "relative",
					overflow: "hidden",
				}}>
				{animation && (
					<div
						className="shimmer"
						style={{
							position: "absolute",
							top: 0,
							left: 0,
							width: "100%",
							height: "100%",
							animation: "shimmer 1.5s infinite",
							background:
								"linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)",
							transform: "skewX(-20deg)",
						}}
					/>
				)}
			</div>
		));

	return (
		<div className="skeleton-container">
			{skeletonElements}
			<style>
				{`
          @keyframes shimmer {
            0% { transform: translateX(-100%) skewX(-20deg); }
            100% { transform: translateX(200%) skewX(-20deg); }
          }
        `}
			</style>
		</div>
	);
};

export const PageSkeleton = ({
	skeletonConfig = {
		containerId: "loading-spinner",
		skeletonElements: [
			{ type: "title", width: "80%" },
			{ type: "text", width: "100%" },
			{ type: "text", width: "100%" },
			{ type: "text", width: "100%" },
		],
	},
}) => {
	return (
		<div
			className="page-skeleton"
			style={{ display: "flex", width: "100%", height: "100vh" }}>
			loading
			{/* <div
				className="skeleton-sidebar"
				style={{
					width: "250px",
					padding: "20px",
					backgroundColor: "#f8f9fa",
				}}>
				<SkeletonLoader count={5} height="20px" width="90%" />
			</div>
			<div className="main-content" style={{ flex: 1, padding: "20px" }}>
				{skeletonConfig.skeletonElements.map((element, index) => (
					<SkeletonLoader
						key={index}
						height={element.type === "title" ? "40px" : "20px"}
						width={element.width}
						margin="15px 0"
					/>
				))}
			</div> */}
		</div>
	);
};
